import 'babel-polyfill';
import ReactDOM from 'react-dom';
import {browserHistory} from 'react-router';
import createRouter from './routes';
import './index.less';

ReactDOM.render(createRouter(browserHistory), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js